module.exports = __webpack_public_path__ + "static/media/services.ee02021b.png";